export default () => {
    return [
        {
            path: '/mailSentLog',
            name: 'mailSentLog',
            component: () => import('./views/mailSentLog.vue'),
        },
    ];
};
